<div class="status-table mb-1">
  <table>
    <thead>
      <th>{{ 'reports.filterLabel.measurement' | translate }}</th>
      <th>{{ 'dashboard.geometries' | translate }}</th>
      <th>{{ differenceTypeDL | labelByChartType: tolerancesOn }}</th>
      <th>%</th>
      <th>{{ differenceTypeDA | labelByChartType: tolerancesOn }}</th>
      <th>%</th>
      <th>{{ differenceTypeDB | labelByChartType: tolerancesOn }}</th>
      <th>%</th>
      <th>{{ differenceTypeDE | labelByChartType: tolerancesOn }}</th>
    </thead>
    <tbody>
      @for (componentStatus of componentsStatus; track componentStatus) {
        @for (angle of availableAngles; track angle; let i = $index) {
          <tr>
            @if (i === 0) {
              <td [rowSpan]="availableAngles.length" class="component">
                <span>{{ componentStatus.component }}</span>
              </td>
            }
            @if (componentStatus.deltaValues | deltaValueOfAngle: angle; as deltaValue) {
              <td>{{ angle }}°</td>
              <td>{{ deltaValue.dL | number: '1.2-2' }}</td>
              <td class="probability" [ngClass]="[deltaValue.probabL | probabilityCssClass]">
                {{ deltaValue.probabL | percent }}
              </td>
              <td>{{ deltaValue.dA | number: '1.2-2' }}</td>
              <td class="probability" [ngClass]="[deltaValue.probabA | probabilityCssClass]">
                {{ deltaValue.probabA | percent }}
              </td>
              <td>{{ deltaValue.dB | number: '1.2-2' }}</td>
              <td class="probability" [ngClass]="[deltaValue.probabB | probabilityCssClass]">
                {{ deltaValue.probabB | percent }}
              </td>
              <td>{{ deltaValue.dE | number: '1.2-2' }}</td>
            }
          </tr>
        }
        <tr class="empty-row"></tr>
      }
    </tbody>
  </table>
</div>
